import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { PAY_URL } from "../../../BaseURL";
import toast from "react-hot-toast";

export const getUserWork = createAsyncThunk('/shift/getUserWork',
    async ({ month }) => {
        try {
            const myurl = `${PAY_URL}/user/get-workday?month=${month}&firm=${localStorage.getItem('PAY_USER_FIRM_ID')}&year=${localStorage.getItem('PAY_USER_YEAR_ID')}`;

            const response = await axios({
                method: 'get',
                url: myurl,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem('PAY_USER_TOKEN')
                },
            });

            const data = response.data;
            // console.log(data, "getUserWork response");

            if (data.success === true) {
                return data;
            } else {
                throw new Error(data.message);
            }
        } catch (error) {
            console.log(error, "error");
            toast.error(error.response.data.message);
            return error
        }
    })

const getUserWorkSlice = createSlice({
    name: "getUserWork",
    initialState: {
        user: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getUserWork.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getUserWork.fulfilled, (state, action) => {
                state.user = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(getUserWork.rejected, (state, action) => {
                state.user = null;
                state.loading = false;
                state.error = action.error.message;
            });
    }
})

export default getUserWorkSlice.reducer;